module.exports = __webpack_public_path__ + "static/gites-icon-e9c856b543bbe2b62ad29bf50e1b09cf.png";